<template>
  <div class="w-50">
    <div class="half-graph-container">
      <div
        class="
          d-flex
          justify-content-between
          align-items-center
          border-bottom
          px-2
          pb-2
        "
      >
        <div class="dashboardAdmin-cards-head ml-2">Role Distribution</div>
        <div
          class="mr-2 pointer"
          v-if="roles.includes('GET_ROLE')"
          @click="goToRoles"
        >
          <img
            src="../../assets/New-imgs/landing-dashboard/redirect.svg"
            alt=""
          />
        </div>
      </div>

      <div
        style="margin: auto"
        v-if="roleDistSpinner"
        class="d-flex justify-content-center align-items-center h-100"
      >
        <b-spinner label="Loading..."></b-spinner>
      </div>

      <div v-else-if="!roleDistSpinner && noRoleData > 0" class="d-flex h-90">
        <div style="width: 80%" class="h-100">
          <div id="pieChart"></div>
        </div>
        <div
          style="width: 20%"
          class="h-100 d-flex align-items-end justify-content-end"
        >
          <div class="legend-container">
            <div
              class="d-flex align-items-center"
              v-for="(data, i) in pieFullData"
              :key="i"
            >
              <div
                class="legend-color-circle mr-1"
                :style="{ backgroundColor: data.colourCode }"
              ></div>
              <div class="legend-heading">{{ data.roleName }}</div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else-if="!roleDistSpinner && noRoleData < 1"
        class="d-flex align-items-center justify-content-center w-100 h-100"
      >
        <img src="../../assets/ReportsNew/roleDistributionNoData.svg" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { roleDistribution } from "../../utils/apiFunctions";
import { rolePieChart } from "vue-d3-charts-hire3x";

export default {
  props: {
    leadKey: Boolean,
  },
  data() {
    return {
      roleDistSpinner: true,
      pieFullData: [],
      noRoleData: null,
      loopvar: 2,
    };
  },
  computed: {
    ...mapGetters(["roles"]),

    ...mapGetters("userVUEX", {
      roleValues: "getRoleValues",
    }),
  },
  created() {
    this.getRoleDitribution();
  },
  methods: {
    async getRoleDitribution() {
      try {
        const payload = {
          userID: this.roleValues.userID,
          lead: this.leadKey,
        };
        const response = await roleDistribution(payload);
        const pieData = response.data.data;
        this.noRoleData = pieData.overallCount;
        const margin = { top: 50, right: 10, bottom: 10, left: 30 };
        const clrCode = [
          "#4070EA",
          "#F5D06E",
          "#038E00",
          "#AD1927",
          "#595959",
          "#269C8A",
        ];
        this.pieFullData = pieData.data.map((d, i) => {
          return {
            roleName: d.roleName,
            percentage: d.percentage,
            count: d.usersCount,
            colourCode: clrCode[i],
          };
        });
        setTimeout(() => {
          if (document.getElementById("pieChart").innerHTML != "") {
            document.getElementById("pieChart").innerHTML = "";
          }
          let pieChart = new rolePieChart();
          pieChart.pieGraph("#pieChart", "pieChart", this.pieFullData, margin);
        }, 200);
      } catch (error) {
        console.error(error);
      }
      this.roleDistSpinner = false;
    },
    goToRoles() {
      this.$router.push({
        name: "AccessControl",
        query: {
          status: "roles",
        },
      });
    },
  },
};
</script>

<style lang="postcss" scoped></style>
